module.exports = __webpack_public_path__ + "static/media/nMyContactsIcon.88a4c70f.svg";